import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import GameModeContext from "./context/GameMode";
import GameScoreContext from "./context/GameScore";
import "./BlockList.css";
import * as blockUtil from "./BlockUtil";
import "./Gameboard.css";
import reverse from "../img/sactx-2-2048x2048-ETC2-Sprites-ccb1f723 1.png";

const Gameboard = () => {
  const GameMode = useContext(GameModeContext);
  const blockListLength = 3;

  useEffect(() => {
    document.querySelectorAll(".square").forEach((node) => {
      node.className = "square";
      // Очищаем внутренний .figure, если он есть
      const figure = node.querySelector(".figure");
      if (figure) {
        figure.className = "figure";
      }
    });
  }, [GameMode.state.gamemode]);

  const makeBlockList = (length) => {
    const blockList = [];
    for (let i = 0; i < length; i++) {
      blockList.push(<Block key={i} />);
    }
    return blockList;
  };

  const makeBlankArray = (size) => {
    const blankArray = [];
    for (let i = 0; i < size; i++) {
      blankArray.push([]);
      for (let j = 0; j < size; j++) {
        blankArray[i].push(j);
      }
    }
    return blankArray;
  };

  return (
    <div>
      <div className="top-gameboard-container">
        {makeBlankArray(GameMode.state.gamemode).map((horizon, index) => {
          return (
            <Horizonboard horizon={horizon} line={index} key={"h" + index} />
          );
        })}
      </div>
      <div id="block-list" className="alert rounded-3">
        {makeBlockList(blockListLength)}
      </div>
    </div>
  );
};

export default Gameboard;

const Horizonboard = ({ horizon, line }) => {
  return (
    <div className="horizon-gameboard">
      {horizon.map((order) => {
        return (
          <Eachboard order={order} line={line} key={line + String(order)} />
        );
      })}
    </div>
  );
};

const Eachboard = ({ order, line }) => {
  return (
    <div className="square" id={line + String(order)}>
      {/* Внутренний div для фигур */}
      <div className="figure"></div>
    </div>
  );
};

const Block = () => {
  return (
    <div className="block">
      <DisplayBlock />
    </div>
  );
};

const DisplayBlock = () => {
  const GameMode = useContext(GameModeContext);
  const GameScore = useContext(GameScoreContext);
  const [buttonReverse, setButtonReverse] = useState(false);
  const [blockState, setBlockState] = useState({
    blockShape: blockUtil.makeBlock()["blockArray"],
    color: blockUtil.makeBlock()["color"],
  });

  useEffect(() => {
    const newState = blockUtil.makeBlock();
    setBlockState((blockState) => ({
      ...blockState,
      blockShape: newState.blockArray,
      color: newState.color,
    }));
  }, [GameMode.state.gamemode]);

  useEffect(() => {
    let filledLine = 0;
    let filled = [];
    const allSquare = document.querySelectorAll(".square");

    for (let i = 0; i < GameMode.state.gamemode; i++) {
      const rowStart = i * GameMode.state.gamemode;
      const rowfilled = [];
      const colfilled = [];
      for (let j = 0; j < GameMode.state.gamemode; j++) {
        const square = allSquare[rowStart + j];
        const figure = square.querySelector(".figure");
        if (
          square.classList.length === 1 ||
          !figure ||
          figure.classList.length === 1
        )
          continue;
        rowfilled.push(square);
      }
      for (let j = 0; j < GameMode.state.gamemode; j++) {
        const square = allSquare[i + j * GameMode.state.gamemode];
        const figure = square.querySelector(".figure");
        if (
          square.classList.length === 1 ||
          !figure ||
          figure.classList.length === 1
        )
          continue;
        colfilled.push(square);
      }
      if (rowfilled.length == GameMode.state.gamemode) {
        filled = filled.concat(rowfilled);
        filledLine++;
      }
      if (colfilled.length == GameMode.state.gamemode) {
        filled = filled.concat(colfilled);
        filledLine++;
      }
    }

    if (filledLine > 0) {
      // Добавляем класс clearing к внутреннему .figure
      filled.forEach((node) => {
        const figure = node.querySelector(".figure");
        if (figure) {
          figure.classList.add("clearing");
        }
      });

      // Ждем завершения анимации (0.6 секунды)
      setTimeout(() => {
        filled.forEach((node) => {
          const figure = node.querySelector(".figure");
          if (figure) {
            figure.className = "figure"; // Сбрасываем классы figure
          }
          node.className = "square"; // Сбрасываем классы square
        });
        GameScore.actions.setGameScore(
          GameMode.state.gamemode * filledLine + GameScore.state.gameScore
        );
      }, 600); // Задержка соответствует длительности анимации
    }
  }, [GameMode.state.gamemode, GameScore.actions, GameScore.state.gameScore]);

  useEffect(() => {
    let isProcessing = false;

    if (isProcessing) return;
    isProcessing = true;

    let filledLine = 0;
    let filled = [];
    const allSquare = document.querySelectorAll(".square");

    for (let i = 0; i < GameMode.state.gamemode; i++) {
      const rowStart = i * GameMode.state.gamemode;
      const rowfilled = [];
      const colfilled = [];
      for (let j = 0; j < GameMode.state.gamemode; j++) {
        const square = allSquare[rowStart + j];
        const figure = square.querySelector(".figure");
        if (
          square.classList.length === 1 ||
          !figure ||
          figure.classList.length === 1
        )
          continue;
        rowfilled.push(square);
      }
      for (let j = 0; j < GameMode.state.gamemode; j++) {
        const square = allSquare[i + j * GameMode.state.gamemode];
        const figure = square.querySelector(".figure");
        if (
          square.classList.length === 1 ||
          !figure ||
          figure.classList.length === 1
        )
          continue;
        colfilled.push(square);
      }
      if (rowfilled.length == GameMode.state.gamemode) {
        filled = filled.concat(rowfilled);
        filledLine++;
      }
      if (colfilled.length == GameMode.state.gamemode) {
        filled = filled.concat(colfilled);
        filledLine++;
      }
    }

    if (filledLine > 0) {
      // Добавляем класс clearing к внутреннему .figure
      filled.forEach((node) => {
        const figure = node.querySelector(".figure");
        if (figure) {
          figure.classList.add("clearing");
        }
      });

      // Ждем завершения анимации (0.6 секунды)
      setTimeout(() => {
        filled.forEach((node) => {
          const figure = node.querySelector(".figure");
          if (figure) {
            figure.className = "figure"; // Сбрасываем классы figure
          }
          node.className = "square"; // Сбрасываем классы square
        });
        GameScore.actions.setGameScore(
          GameMode.state.gamemode * filledLine + GameScore.state.gameScore
        );
        isProcessing = false;
      }, 600); // Задержка соответствует длительности анимации
    } else {
      isProcessing = false;
    }
  }); // Пустой массив зависимостей

  function rotateShape(shape) {
    const rows = shape.length;
    const cols = shape[0].length;
    const rotatedShape = [];

    for (let j = 0; j < cols; j++) {
      rotatedShape[j] = [];
      for (let i = rows - 1; i >= 0; i--) {
        rotatedShape[j].push(shape[i][j]);
      }
    }

    return rotatedShape;
  }

  const isCanMerge = useCallback(
    (board, block, startRow, startCol, blockRow, blockCol) => {
      if (
        !board ||
        !block ||
        board.length === 0 ||
        board[0].length === 0 ||
        block.length === 0 ||
        block[0].length === 0
      ) {
        return false;
      }

      if (
        startRow < 0 ||
        startCol < 0 ||
        startRow + blockRow > board.length ||
        startCol + blockCol > board[0].length
      ) {
        return false;
      }

      try {
        for (let i = 0; i < blockRow; i++) {
          for (let j = 0; j < blockCol; j++) {
            if (
              block[i] &&
              block[i][j] === 1 &&
              board[startRow + i] &&
              board[startRow + i][startCol + j] === 1
            ) {
              return false;
            }
          }
        }
      } catch (error) {
        return false;
      }
      return true;
    },
    []
  );

  useEffect(() => {
    const checkGameEnd = () => {
      const allBlockContainer =
        document.getElementsByClassName("block-container");
      const board = getGameBoard();

      if (!allBlockContainer || allBlockContainer.length === 0) {
        return;
      }

      if (!board || board.length === 0 || board[0].length === 0) {
        return;
      }

      let canPlaceAnyBlock = false;

      for (
        let blockIndex = 0;
        blockIndex < allBlockContainer.length;
        blockIndex++
      ) {
        const blockContainer = allBlockContainer[blockIndex];
        let block = blockContainer.getAttribute("data-shape");

        if (!block) continue;

        try {
          block = block
            .split("/")
            .map((each) => each.split(",").map((str) => Number(str)));
        } catch (error) {
          continue;
        }

        const rotations = [
          block,
          rotateShape(block),
          rotateShape(rotateShape(block)),
          rotateShape(rotateShape(rotateShape(block))),
        ];

        for (const rotatedBlock of rotations) {
          if (!rotatedBlock || !rotatedBlock[0]) continue;
          const blockRows = rotatedBlock.length;
          const blockCols = rotatedBlock[0].length;

          for (
            let boardRow = 0;
            boardRow <= board.length - blockRows;
            boardRow++
          ) {
            for (
              let boardCol = 0;
              boardCol <= board[0].length - blockCols;
              boardCol++
            ) {
              if (
                isCanMerge(
                  board,
                  rotatedBlock,
                  boardRow,
                  boardCol,
                  blockRows,
                  blockCols
                )
              ) {
                canPlaceAnyBlock = true;
                break;
              }
            }
            if (canPlaceAnyBlock) break;
          }
          if (canPlaceAnyBlock) break;
        }
        if (canPlaceAnyBlock) break;
      }

      if (!canPlaceAnyBlock && allBlockContainer.length > 0) {
        document.getElementById("game-over").style.display = "block";
      }
    };

    checkGameEnd();
  }, [blockState, isCanMerge]);

  const onmousedown = (event) => {
    const container = document.querySelector(".top-container");
    const SCALE_REGEX = /scale\(([-+]?\d*\.?\d+)\)/;
    const getScale = () => {
      var match = container.style.transform.match(SCALE_REGEX);
      if (match) {
        return match[1];
      } else {
        return 1;
      }
    };
    const scale = getScale();
    setButtonReverse(true);
    const blockContainer = event.currentTarget;
    const childBlockList = blockContainer.querySelectorAll("div.block-child");
    const squareWidth = document.querySelector(".square").clientWidth;
    childBlockList.forEach((childBlock) => {
      childBlock.style.width = squareWidth * scale + "px";
      childBlock.style.height = squareWidth * scale + "px";
    });
    let shiftX;
    let shiftY;
    if (event.touches && event.touches.length > 0) {
      const touch = event.touches[0];
      shiftX =
        (touch.clientX - blockContainer.getBoundingClientRect().left) / scale;
      shiftY =
        (touch.clientY - blockContainer.getBoundingClientRect().top) / scale;
    } else {
      shiftX =
        (event.clientX - blockContainer.getBoundingClientRect().left) / scale;
      shiftY =
        (event.clientY - blockContainer.getBoundingClientRect().top) / scale;
    }

    blockContainer.style.position = "absolute";
    blockContainer.style.zIndex = 1000;

    const parentNode = blockContainer.parentNode;
    document.body.append(blockContainer);

    function moveAt(pageX, pageY) {
      blockContainer.style.left = pageX - shiftX + "px";
      blockContainer.style.top = pageY - shiftY + "px";
    }

    if (event.touches && event.touches.length > 0) {
      const touch = event.touches[0];
      moveAt(touch.pageX, touch.pageY);
    } else {
      moveAt(event.pageX, event.pageY);
    }

    function onMouseMove(event) {
      if (event.touches && event.touches.length > 0) {
        const touch = event.touches[0];
        moveAt(touch.pageX, touch.pageY);
      } else {
        moveAt(event.pageX, event.pageY);
      }
    }

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("touchmove", onMouseMove);

    if (event.touches && event.touches.length > 0) {
      blockContainer.ontouchend = mouseUp;
    } else {
      blockContainer.onmouseup = mouseUp;
    }
    function mouseUp() {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("touchmove", onMouseMove);
      const isValidPosition = (block) => {
        const blockList = block.querySelectorAll(".block-child");
        const targetSqaure = [];
        const blockColor = [];
        try {
          for (let i = 0; i < blockList.length; i++) {
            const childBlock = blockList.item(i);
            if (
              childBlock.getAttribute("data-backgroundColor") === "transparent"
            )
              continue;
            blockColor.push(childBlock.getAttribute("data-backgroundColor"));
            const { x: presentX, y: presentY } =
              childBlock.getBoundingClientRect();
            block.hidden = true;
            function getElementFromPointAlternative(x, y) {
              const squares = document.querySelectorAll(".square");

              for (const square of squares) {
                const rect = square.getBoundingClientRect();
                if (
                  x >= rect.left &&
                  x <= rect.right &&
                  y >= rect.top &&
                  y <= rect.bottom
                ) {
                  return square;
                }
              }
              return null;
            }

            const objectBelow = getElementFromPointAlternative(
              presentX + (squareWidth * scale) / 2,
              presentY + (squareWidth * scale) / 2
            );

            block.hidden = false;
            if (!objectBelow) {
              return;
            }
            if (objectBelow.className !== "square") {
              return;
            }
            targetSqaure.push(objectBelow);
          }

          targetSqaure.forEach((square) => {
            square.className = `square ${blockColor[0]}`; // Добавляем цвет к .square
            const figure = square.querySelector(".figure");
            if (figure) {
              figure.className = `figure ${blockColor[0]}`; // Добавляем цвет к .figure
            }
          });

          const newState = blockUtil.makeBlock();
          setBlockState({
            ...blockState,
            blockShape: newState.blockArray,
            color: newState.color,
          });
        } finally {
          setButtonReverse(false);
          parentNode.append(block);
          block.style.position = "";
          block.style.zIndex = "";
          block.style.left = "";
          block.style.top = "";
          blockList.forEach((childBlock) => {
            childBlock.style.width = "40px";
            childBlock.style.height = "40px";
          });
        }
      };

      isValidPosition(blockContainer);
    }
  };

  const getGameBoard = () => {
    const gameboardContainer = document.getElementsByClassName(
      "top-gameboard-container"
    )[0];
    if (!gameboardContainer) {
      return [];
    }
    const board = [];
    gameboardContainer.childNodes.forEach((horizon) => {
      let line = [];
      horizon.childNodes.forEach((each) => {
        if (each.classList.length === 1) line.push(0);
        else line.push(1);
      });
      board.push(line);
    });

    return board;
  };

  const isRotate = useMemo(() => {
    function rotateShape(shape) {
      const rows = shape.length;
      const cols = shape[0].length;
      const rotatedShape = [];

      for (let j = 0; j < cols; j++) {
        rotatedShape[j] = [];
        for (let i = rows - 1; i >= 0; i--) {
          rotatedShape[j].push(shape[i][j]);
        }
      }

      return rotatedShape;
    }

    const shape = blockState.blockShape;
    const rotated = rotateShape(shape);
    if (
      shape.length !== rotated.length ||
      shape[0].length !== rotated[0].length
    ) {
      return false;
    }

    for (let i = 0; i < shape.length; i++) {
      for (let j = 0; j < shape[0].length; j++) {
        if (shape[i][j] !== rotated[i][j]) {
          return false;
        }
      }
    }

    return true;
  }, [blockState.blockShape]);

  const handleRotate = () => {
    const shape = blockState.blockShape;
    const rows = shape.length;
    const cols = shape[0].length;
    const rotatedShape = [];

    for (let j = 0; j < cols; j++) {
      rotatedShape[j] = [];
      for (let i = rows - 1; i >= 0; i--) {
        rotatedShape[j].push(shape[i][j]);
      }
    }
    setBlockState((prev) => ({
      ...prev,
      blockShape: rotatedShape,
    }));
  };

  return (
    <div>
      <div
        className="block-reverse"
        style={{ opacity: !isRotate && !buttonReverse ? "1" : "0" }}
        onClick={handleRotate}
      >
        <img src={reverse} />
      </div>
      <div
        className="block-container"
        onDragStart={() => false}
        onMouseDown={onmousedown}
        onTouchStart={onmousedown}
        data-shape={blockState.blockShape.join("/")}
      >
        {blockState.blockShape.map((line) => {
          return (
            <div className="sub-block-container">
              {line.map((each) => {
                return each === 1 ? (
                  <div
                    className={`block-child fill ${blockState.color}`}
                    data-backgroundColor={blockState.color}
                  ></div>
                ) : (
                  <div
                    className="block-child blank"
                    data-backgroundColor="transparent"
                  ></div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};
